module.exports = __webpack_public_path__ + "img/63.60088746.jpg";